const module = {
  routes: [
    {
      path: '/integrators',
      component: () => import('@/modules/integrators/pages/index.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    },
    {
      path: '/integrators/:id',
      component: () => import('@/modules/integrators/pages/_id.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
